<template>
  <div class="payment-popup">
    <div class="popup-box" :style="{ width, top }" ref="popupBox">
      <div v-if="!showSuccessPart" class="box-header">
        <slot name="header">
          <h6>{{ header }}</h6>
        </slot>
        <img
          src="@/assets/icons/popup-close.png"
          alt="closes"
          class="header-close"
          @click="closePopupCB()"
        />
        <div class="clearfix"></div>
      </div>
      <div class="session-exp-popup">
        <div
          class="row"
          v-if="!showSuccessPart && paymentContent"
          style="margin:0;"
        >
          <p class="summary">SUMMARY</p>
          <div class="row mlmr0">
            <div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6 plpr0">
              <div class="movie-details">
                <p class="movie-title">{{ paymentContent.title }}</p>
              </div>
            </div>
            <div class="col-xlg-3 col-lg-3 col-md-3 col-sm-6 col-xs-6"></div>
            <div class="col-xlg-3 col-lg-3 col-md-3 col-sm-6 col-xs-6">
              <div class="price">
                <div
                  style="cursor:pointer;"
                  class="price-info"
                  @click="togglePriceMenu"
                >
                  <img id="pricearrow" :src="iconArrowDown" />
                </div>
                <p v-if="contentPrice">
                  {{ contentPrice.currencysymbol }} <span>{{ price }}</span>
                </p>
              </div>
            </div>
          </div>
          <transition name="slide">
            <div class="row price-detail" v-if="showPriceDetail">
              <div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"></div>
              <div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <div class="row price-detail">
                  <div
                    class="col-xlg-7 col-lg-7 col-md-7 col-sm-7 col-xs-7"
                    style="padding-right:0px;"
                  >
                    <p class="amount-label">Item Price</p>
                    <p v-if="discount" class="amount-label">Discount</p>
                    <!-- <p v-if="taxrate" class="amount-label" >Tax</p> -->
                    <!-- <p class="amount-label">Total Amount</p> -->
                  </div>
                  <div
                    class="col-xlg-5 col-lg-5 col-md-5 col-sm-5 col-xs-5"
                    style="padding-left:0px;padding-right:0px;"
                  >
                    <p class="amount-style">
                      {{ contentPrice.currencysymbol }} {{ accessFee }}
                    </p>
                    <p v-if="discount" class="amount-style">
                      {{ contentPrice.currencysymbol }} {{ discount }}
                    </p>
                    <!-- <p v-if="taxrate" class="amount-style" >{{ contentPrice.currencysymbol }} {{taxrate}}</p> -->
                    <!-- <p class="amount-style">{{ getCurrency(content.price[0].currency) }} {{price}}</p> -->
                  </div>
                </div>
              </div>
            </div>
          </transition>
          <div class="row mlmr0 coupon-container">
            <div class="col-xlg-8 col-lg-8 col-md-8 col-sm-6 col-xs-6">
              <input
                v-if="showCouponInput"
                class="coupon"
                v-model="coupon"
                placeholder="COUPON CODE"
                type="text"
                width="100%"
                maxlength="12"
              />
              <p v-else class="coupon">{{ coupon }}</p>
            </div>
            <div class="col-xlg-4 col-lg-4 col-md-4 col-sm-6 col-xs-6">
              <p v-if="showCouponInput" @click="verifyCoupon()" class="apply">
                Apply
              </p>
              <p v-else @click="removeCoupon()" class="apply">Remove</p>
            </div>
          </div>
          <div class="vlt-lgn-btns">
            <button
              type="submit"
              class="btn-lg-primary"
              ref="loginBtnSubmit"
              @click="proceed"
              v-if="showProceedButton"
            >
              <p>Proceed</p>
            </button>
            <div v-if="showPaymentButton" id="paypal-button-container1"></div>
          </div>
        </div>
        <div v-if="showSuccessPart && paymentContent">
          <img
            src="@/assets/icons/popup-close.png"
            alt="closes"
            class="header-close"
            @click="closePopupCB()"
          />
          <div>
            <p class="payment-success">You have Successfully Purchased</p>
          </div>
          <div class="purchased-content-image">
            <div class="outer">
              <div class="purchase-success">
                <img src="@/assets/icons/icons8-checkmark .svg" />
              </div>
              <!-- <img  src="@/assets/icons/success.png"/> -->
              <img
                class="contentImage"
                width="100%"
                height="100%"
                :src="getPoster(paymentContent, 'PORTRAIT')"
              />
            </div>
            <p>{{ paymentContent.title }}</p>
          </div>
          <div class="hrline"></div>
          <div class="row mlmr0 success-info">
            <p>Hi {{ AppUser.subscribername }},</p>
            <p>Congratulations!</p>
            <p>Your payment has been processed successfully</p>
          </div>
          <div class="hrline"></div>
          <div class="row mlmr0 amount-info">
            <div
              class="col-xlg-8 col-lg-8 col-md-8 col-sm-8 col-xs-8 Gplpr0"
              style="padding-left: 0px;"
            >
              <p class="amount-recived">Amount Received</p>
              <p v-if="transactionID" class="transactionandorderid">
                Transaction ID : {{ transactionID }}
              </p>
              <p v-if="orderID" class="transactionandorderid">
                Order ID : {{ orderID }}
              </p>
            </div>
            <div class="col-xlg-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
              <p style="text-align:end;">
                <span class="doller">{{ contentPrice.currencysymbol }}</span>
                <span class="success-price">{{ price }}</span>
              </p>
            </div>
          </div>
        </div>
        <FormError
          v-show="paymentError"
          :message="paymentError"
          style="margin-top: 20px;"
        ></FormError>
        <Loading v-show="showLoading"></Loading>
        <div v-if="successMessage" class="success-message">
          <p>{{ successMessage }}</p>
        </div>
      </div>
    </div>
    <div class="popup-overlay"><span></span></div>
  </div>
</template>

<script>
import Loading from "@/components/Templates/Loading.vue";
import { mapGetters, mapMutations, mapActions } from "vuex";
import FormError from "@/components/Templates/FormError.vue";
import Utility from "@/mixins/Utility";
import App from "@/mixins/App";
import Content from "@/mixins/Content";
import GoogleAnalytics from "@/mixins/GoogleAnalytics";
import { EventBus } from "@/main";

export default {
  name: "PopupResetPassword",
  props: ["closePopupCB", "paymentData"],
  data() {
    return {
      paymentContent: null,
      top: "50%",
      width: "40%",
      header: "Payment",
      price: 0.0,
      taxrate: 0,
      iconArrowDown: require("@/assets/icons/sort-down-black.png"),
      iconArrowUp: require("@/assets/icons/sort-up-black.png"),
      giftArrowDown: require("@/assets/icons/left-arrow-filled-50-black.png"),
      giftArrowUp: require("@/assets/icons/forward-filled-50-black.png"),
      showPriceDetail: false,
      showGiftDetail: false,
      giftShareTitle: "Share this movie with love",
      recipientName: null,
      recipientEmail: null,
      recipientCountry: null,
      giftingToOther: null,
      countryList: null,
      showCountryList: false,
      showGiftedInfo: false,
      formError: "",
      coupon: null,
      paymentType: null,
      showCouponInput: true,
      paymentError: null,
      searchCountry: null,
      cardHolderName: null,
      cardNumber: null,
      showCardContainer: false,
      cardMonth: null,
      cardYear: null,
      cardCVV: null,
      rememberMe: false,
      showSuccessPart: false,
      transactionID: null,
      orderID: null,
      payemntInitData: null,
      //
      couponData: null,
      showPaymentButton: true,
      showLoading: false,
      successMessage: null,
      discount: null,
      showProceedButton: false,
      //
      contentPrice: null,
      flagPaypal: false,
    };
  },
  components: {
    Loading,
    FormError,
  },
  watch: {
    paymentError(value) {
      if (value) {
        setTimeout(() => {
          this.paymentError = null;
        }, 5000);
      }
    },
    successMessage(value) {
      if (value) {
        setTimeout(() => {
          this.successMessage = null;
        }, 5000);
      }
    },
    paymentContent() {
      if (this.paymentContent) {
        this.getContentCurrency();
      }
    },
  },
  computed: {
    ...mapGetters(["AppUser", "AppConfig"]),
  },
  mounted() {
    if (this.paymentData.content) {
      this.paymentContent = this.paymentData.content;
      setTimeout(() => {
        // console.log("done")
        this.renderPaypalButton();
        // this.quality('HD');
      }, 1000);
    } else if (this.paymentData.contentid) {
      this.getContent();
    }
  },
  methods: {
    ...mapActions(["actPaymentInit", "actCheckCoupon", "actGetContent"]),
    ...mapMutations(["commitNewTicket"]),
    actChange() {
      this.flagPaypal = true;
      // console.log("this.flagPaypal", this.flagPaypal);
    },
    getContentCurrency() {
      this.contentPrice = this.getContentPrice(this.paymentContent);
      if (this.contentPrice) {
        this.calculatePriceAndTax();
      }
    },
    calculatePriceAndTax() {
      this.price = this.contentPrice.amount / 100;
      this.taxrate = (this.contentPrice.taxrate / 100).toFixed(2);
      // if (contentQuality.currency == 'INR'){
      //   this.taxrate= ((contentQuality[0].taxrate /100) * this.price).toFixed(2)

      // } else{
      //   this.taxrate = (contentQuality[0].amount - (contentQuality[0].amount / (1+ (contentQuality[0].taxrate /100)))).toFixed(2);
      //   this.taxrate = (this.taxrate / 100).toFixed(2)
      //   // this.taxrate = (contentQuality[0].taxrate / 100).toFixed(2);
      // }
      this.accessFee = Number(this.price).toFixed(2);
    },
    proceed() {
      if (this.couponData) {
        let params = {
          amount: this.contentPrice.amount,
          currency: this.contentPrice.currency,
          quality: this.contentPrice.quality,
          paymenttype: "TICKET",
          gwprovider: "PAYPAL",
          contentid: this.paymentContent.contentid,
        };
        //
        // params.amount = this.couponData.discountedamount;
        params.couponid = this.couponData.discountid;
        //
        this.showLoading = true;
        this.actPaymentInit(params).then((response) => {
          this.showLoading = false;
          if (response.success) {
            this.transactionID = response.success;
            this.paymentContent.expiry = response.expiry;
            this.paymentContent.poster = this.getPoster(
              this.paymentContent,
              "PORTRAIT"
            );
            this.addPurchasedContentToFire(this.paymentContent);
            this.commitNewTicket(true);
            this.showSuccessPart = true;
            //
            let GA = {
              "Event Label": "Success",
              ContentTitle: this.paymentContent.title,
              ContentID: this.paymentContent.contentid,
              Category: this.paymentContent.category,
              Amount: this.contentPrice.amount / 100,
              Currency: this.contentPrice.currency,
              Quality: this.contentPrice.quality,
              GWProvider: "PAYPAL",
            };
            if (this.couponData) {
              GA.CouponID = this.couponData.discountid;
            }
            GA["Event Label"] = "Success";
            GA.PaymentStatus = "SUCCESS";
            GA.TicketID = this.transactionID;
            //
            this.TicketPurchaseEvent(GA);
            //
            let paymentdata = {
              contentid: this.paymentContent.contentid,
              ticketid: this.transactionID,
              ticketprice: this.contentPrice.amount,
              expiry: response.expiry,
            };
            EventBus.$emit("TicketPurchase", paymentdata);
          } else {
            let GA = {
              "Event Label": "Success",
              ContentTitle: this.paymentContent.title,
              ContentID: this.paymentContent.contentid,
              Category: this.paymentContent.category,
              Amount: this.contentPrice.amount / 100,
              Currency: this.contentPrice.currency,
              Quality: this.contentPrice.quality,
              GWProvider: "PAYPAL",
            };
            if (this.couponData) {
              GA.CouponID = this.couponData.discountid;
            }
            GA["Event Label"] = "Failure";
            GA.PaymentStatus = "FAILUED";
            GA.ErrorCode = response.error;
            GA.ErrorMessage = response.reason
              ? response.reason
              : response.message;
            //
            this.TicketPurchaseEvent(GA);
            //
            this.paymentError = response.error
              ? response.message
              : "Please try again later";
          }
        });
      }
    },
    getContent() {
      this.showLoading = true;
      this.paymentContent = null;
      this.actGetContent(this.paymentData.contentid)
        .then((response) => {
          this.showLoading = false;
          if (response) {
            this.paymentContent = response;
            if (this.paymentData.coupon) {
              this.coupon = this.paymentData.coupon;
            }
            setTimeout(() => {
              this.renderPaypalButton();
              // this.quality('HD');
            }, 100);
          } else {
            this.paymentError = response;
          }
        })
        .catch((error) => {
          this.paymentError = error.reason;
        });
    },
    quality(value) {
      let contentQuality = this.paymentContent.price.filter(
        (p) => p.quality == value
      );
      if (contentQuality.length > 0) {
        this.price = contentQuality[0].amount / 100;
        if (contentQuality.currency == "INR") {
          this.taxrate = (
            (contentQuality[0].taxrate / 100) *
            this.price
          ).toFixed(2);
        } else {
          this.taxrate = (
            contentQuality[0].amount -
            contentQuality[0].amount / (1 + contentQuality[0].taxrate / 100)
          ).toFixed(2);
          this.taxrate = (this.taxrate / 100).toFixed(2);
          // this.taxrate = (contentQuality[0].taxrate / 100).toFixed(2);
        }
        this.accessFee = Number(this.price - this.taxrate).toFixed(2);
      }
    },
    renderPaypalButton() {
      // Render the PayPal button into #paypal-button-container1
      let self = this;
      let data = {};
      if (self.AppConfig.payment.PAYPAL.paypalenv === "sandbox") {
        data.sandbox = self.AppConfig.payment.PAYPAL.paypalclientid;
      } else {
        data.production = self.AppConfig.payment.PAYPAL.paypalclientid;
      }

      var paypal = window.paypal;

      paypal.Button.render(
        {
          locale: "",
          country: "",
          env:
            self.AppConfig.payment.PAYPAL.paypalenv === "live" ||
            self.AppConfig.payment.PAYPAL.paypalenv === "production"
              ? "production"
              : "sandbox",
          client: data,
          // client: { production: 'AY9vfUcWx_EuzIOmiQKkHQYFASJq1Ue7FuCLSxUZQo1hvoX4LXvP8KU0YeiQAqEJxs_3Vq0S9RHFX72s' },
          commit: true,
          style: {
            size: "responsive",
            color: "blue",
            shape: "rect",
            tagline: false,
            label: "paypal",
            response: true,
          },
          funding: {
            allowed: [],
            disallowed: [paypal.FUNDING.CARD, paypal.FUNDING.CREDIT],
          },
          // Enable Pay Now checkout flow (optional)

          // Set up a payment
          payment: function() {
            self.paymentError = null;
            let params = {};
            //  console.log("contentPriceDetails");
            if (
              self.contentPrice.currency === "INR" ||
              self.contentPrice.currency === "IDR" ||
              self.contentPrice.currency === "VND"
            ) {
              params.fallback_currency = "INR";
            }
            params.amount = self.contentPrice.amount;
            params.currency = self.contentPrice.currency;
            params.quality = self.contentPrice.quality;
            params.paymenttype = "TICKET";
            params.gwprovider = "PAYPAL";
            params.contentid = self.paymentContent.contentid;
            // console.log("paypal params", params);
            if (self.couponData && self.couponData.discountedamount) {
              // params.amount = self.couponData.discountedamount
              params.couponid = self.couponData.discountid;
            }

            params.intent = "sale";
            params.payer = {
              payment_method: "paypal",
            };
            params.application_context = {
              shipping_preference: "NO_SHIPPING",
            };

            return self
              .actPaymentInit(params)
              .then((response) => {
                // console.log("paypal response", response);
                if (response.success) {
                  self.payemntInitData = response;
                  return self.payemntInitData.payload.paypalorder.id;
                } else {
                  self.paymentError = response
                    ? response.reason
                    : "Please try again later";
                  return;
                }
              })
              .catch((error) => {
                if (error.status === 401) {
                  self.formError = "Session Expired.Please try again later";
                  self.sessionExpiredCB();
                  EventBus.$emit("logOut");
                  // window.location.reload()
                  self.$router.push({ name: "Home" });
                }
              });
          },
          // Execute the payment
          onAuthorize: function(data, actions) {
            //  console.log("onAuthorize", data);
            self.paymentCallback(data, "SUCCESS");
          },
          onCancel: function(data, actions) {
            //  console.log("onCancel", data);
            self.paymentCallback(data, "CANCELLED");
          },
          // onError: function(err) {
          //   console.log("onError", err);
          //   if (
          //     err.message !== "Can not open popup window - blocked" &&
          //     err.message !== "No response from window - cleaned up"
          //   ) {
          //     self.paymentCallback(err, "FAILED");
          //   }
          //   // Show an error page here, when an error occurs
          // }
        },
        "#paypal-button-container1"
      );
    },
    paymentCallback(res, status) {
      let url = this.payemntInitData.payload.confirmurl;
      this.showLoading = true;
      this.showPaymentButton = false;

      var form = new FormData();
      form.append("reference_id", this.payemntInitData.payload.order_id);
      if (status === "SUCCESS")
        form.append("orderid", this.payemntInitData.payload.paypalorder.id);
      form.append("status", status);

      fetch(url, {
        method: "POST",
        mimeType: "multipart/form-data",
        body: form,
      })
        .then((response) => response.json())
        .then((data) => {
          this.showLoading = false;
          this.showPaymentButton = true;
          // console.log("paymentCallback", data);
          let GA = {
            "Event Label": "Success",
            ContentTitle: this.paymentContent.title,
            ContentID: this.paymentContent.contentid,
            Category: this.paymentContent.category,
            Amount: this.contentPrice.amount / 100,
            Currency: this.contentPrice.currency,
            Quality: this.contentPrice.quality,
            GWProvider: "PAYPAL",
          };
          if (this.couponData) {
            GA.CouponID = this.couponData.discountid;
          }
          if (status === "SUCCESS" && data.success) {
            // console.log("Success", data.success, data.expiry);
            GA["Event Label"] = "Success";
            GA.PaymentStatus = "SUCCESS";
            GA.TicketID = this.payemntInitData.payload.paypalorder.id;
            this.TicketPurchaseEvent(GA);
            this.transactionID = data.success;
            this.paymentContent.expiry = data.expiry;
            this.orderID = this.payemntInitData.payload.paypalorder.id;
            this.paymentContent.poster = this.getPoster(
              this.paymentContent,
              "PORTRAIT"
            );
            this.addPurchasedContentToFire(this.paymentContent);
            this.commitNewTicket(true);
            // console.log("Success----------", data.success, data.expiry);
            this.showSuccessPart = true;
            //
            let paymentData = {
              contentid: this.paymentContent.contentid,
              ticketid: this.transactionID,
              ticketprice: this.contentPrice.amount,
              expiry: data.expiry,
            };
            EventBus.$emit("TicketPurchase", paymentData);
          } else if (status === "CANCELLED") {
            GA["Event Label"] = "Failure";
            GA.PaymentStatus = "CANCELLED";
            GA.TicketID = this.payemntInitData.payload.paypalorder.id;
            //
            this.TicketPurchaseEvent(GA);
            //
            setTimeout(() => {
              this.renderPaypalButton();
            }, 100);
            this.paymentError = "Payment cancelled";
          } else if (status === "FAILED") {
            // GA['Event Label'] = 'Failure'
            // GA.PaymentStatus = 'FAILED'
            // GA.TicketID = this.payemntInitData.payload.paypalorder.id
            // //
            // this.TicketPurchaseEvent(GA)
            //
            setTimeout(() => {
              this.renderPaypalButton();
            }, 100);
            this.paymentError = "Payment FAILED.Please try again later";
          } else if (data.error) {
            GA["Event Label"] = "Failure";
            GA.PaymentStatus = "FAILED";
            GA.TicketID = this.payemntInitData.payload.paypalorder.id;
            GA.ErrorCode = data.error;
            GA.ErrorMessage = data.reason;
            //
            this.TicketPurchaseEvent(GA);
            //
            setTimeout(() => {
              this.renderPaypalButton();
            }, 100);
            this.paymentError = data.error
              ? data.reason
              : "Please try again later";
          }
        })
        .catch((error) => {
          if (error.status === 401) {
            this.formError = "Session Expired.Please try again later";
            this.sessionExpiredCB();
            EventBus.$emit("logOut");
            // window.location.reload()
            this.$router.push({ name: "Home" });
          }
        });
    },
    getPoster(content, type) {
      if (content.posters.length) {
        let landscapeposters = content.posters.filter(
          (pos) => pos.orientation === type
        );
        if (landscapeposters.length) {
          let posterIndex = landscapeposters.findIndex(
            (pos) => pos.quality === "HD"
          );
          if (posterIndex > -1) {
            return landscapeposters[posterIndex].url;
          } else {
            return landscapeposters[0].url;
          }
        }
      }
    },
    completePurchase() {
      this.showSuccessPart = true;
    },
    removeCoupon() {
      // console.log("------")
      this.coupon = "";
      this.couponData = null;
      this.showCouponInput = true;
      // this.quality('HD');
      this.calculatePriceAndTax();
      this.discount = null;
      this.showPaymentButton = true;
      if (this.showProceedButton) {
        setTimeout(() => {
          this.renderPaypalButton();
        }, 100);
      }
      this.showProceedButton = false;
    },
    verifyCoupon() {
      if (!this.coupon) {
        this.paymentError = "Please enter coupon";
        return;
      }
      this.paymentError = null;
      this.showCouponInput = false;
      //
      let data = {
        quality: this.contentPrice.quality,
        couponid: this.coupon,
        gwprovider: "PAYPAL",
        contentid: this.paymentContent.contentid,
        currency: this.contentPrice.currency,
      };
      //
      this.showLoading = true;
      this.actCheckCoupon(data)
        .then((response) => {
          this.showLoading = false;
          // console.log("actCheckCoupon", response);
          if (!response.error) {
            //
            let GA = {
              "Event Label": "Success",
              ContentTitle: this.paymentContent.title,
              ContentID: this.paymentContent.contentid,
              Category: this.paymentContent.category,
              Currency: this.contentPrice.currency,
              GWProvider: "PAYPAL",
              CouponID: response.discountid,
            };
            // this.CouponClaimEvent(GA);
            //
            this.couponData = response;
            if (this.couponData.discountedamount > 0) {
              // this.taxrate = (this.couponData.discountedamount - (this.couponData.discountedamount / (1+ (this.contentPrice.taxrate /100)))).toFixed(2);
              // this.taxrate = (this.contentPrice.taxrate / 100).toFixed(2)
              // console.log('discountedamount', this.taxrate)
              // this.price = ((this.couponData.discountedamount - this.taxrate) / 100).toFixed(2)
              // console.log('discountedPrice', this.price)
              // this.discount = (this.couponData.totaldiscount / 100).toFixed(2)
              // this.successMessage = 'Coupon Added Successfully.'
              // console.log('accessFee', ((this.couponData.price - this.couponData.discountedamount) / 100))

              // this.accessFee = ((this.couponData.price - this.couponData.discountedamount) / 100).toFixed(2)

              // let temp = (this.couponData.price / 100 - this.taxrate).toFixed(
              //   2
              // ); // 155.82
              let temp = (this.couponData.price / 100).toFixed(2);
              // console.log("temp", temp);

              let contentPrice = Number(temp) + Number(this.taxrate); //155.82+3.18
              // console.log("contentPrice", contentPrice);
              // console.log(
              //   "topay",
              //   (Number(this.couponData.price) -
              //     Number(this.couponData.discountedamount)) /
              //     100
              // );
              let topay = (
                Number(this.couponData.discountedamount) / 100
              ).toFixed(2);
              // console.log("topay", topay);

              this.price = topay;
              this.discount = (this.couponData.totaldiscount / 100).toFixed(2);
              this.accessFee = temp;
              //
              GA.Amount = this.couponData.discountedamount / 100;
              this.CouponClaimEvent(GA);
            } else if (this.couponData.discountedamount == 0) {
              this.price = (0).toFixed(2);
              this.taxrate = (0).toFixed(2);
              this.accessFee = (this.couponData.price / 100).toFixed(2);
              this.discount = (this.couponData.totaldiscount / 100).toFixed(2);
              this.showPaymentButton = false;
              this.showProceedButton = true;
              this.successMessage = "Coupon Added Successfully.";
              //
              GA.Amount = this.contentPrice.amount / 100;
              this.CouponClaimEvent(GA);
            }
          } else {
            //
            this.paymentError = response.reason;
            this.removeCoupon();
            //
            let Analytics = {
              "Event Label": "Failure",
              ContentTitle: this.paymentContent.title,
              ContentID: this.paymentContent.contentid,
              Category: this.paymentContent.category,
              Amount: this.contentPrice.amount,
              Currency: this.contentPrice.currency,
              // GWProvider: "PAYTM",
              ErrorMessage: response.reason,
              ErrorCode: response.error,
            };
            this.CouponClaimEvent(Analytics);
          }
        })
        .catch((error) => {});
    },
    togglePriceMenu() {
      let elment = document.getElementById("pricearrow");
      if (elment) {
        elment.src = this.showPriceDetail
          ? this.iconArrowDown
          : this.iconArrowUp;
      }
      this.showPriceDetail = !this.showPriceDetail;
    },
  },
  mixins: [App, Content, Utility, GoogleAnalytics],
};
</script>

<style lang="scss" scoped>
@import "~sass/modules/variables";
.textCenter {
  text-align: center;
}

.payment-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: $clr-dark-hlt;
  z-index: 8888;
  // overflow-y: scroll;
  .popup-box {
    position: fixed;
    background-color: #fff;
    z-index: 8889;
    // padding: 15px 20px;
    border-radius: 4px;
    min-width: 320px;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
    // max-height: 80%;
    // overflow-y: auto;
  }
  .popup-form {
    margin-top: 10px;
  }
  .box-header {
    // margin-bottom: 40px;
    padding: 15px;
    -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
    -moz-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
    h6 {
      text-align: center;
      width: 100%;
      float: left;
      // text-transform: uppercase;
      font-style: normal;
      color: #212121;
      font-size: 22px;
      font-family: "ProximanovaBold";
    }
  }
  .header-close {
    position: absolute;
    cursor: pointer;
    float: right;
    width: 34px;
    top: 12px;
    right: 2%;
    opacity: 0.7;
    &:hover {
      opacity: 1;
    }
  }
  .popup-message {
    text-align: center;
    margin: 1em;
    display: block;
  }
}
.session-exp-popup {
  padding: 5%;
  // max-height: 525px;
  // overflow-y: scroll;
  margin-right: 5px;
  /* width */
  &::-webkit-scrollbar {
    width: 8px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    //box-shadow: inset 0 0 5px grey;
    border-radius: 5px;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #b9bcb9;
    border-radius: 5px;
  }
}
.summary {
  color: rgba(33, 33, 33, 1);
  font-family: "ProximanovaBold";
  font-size: 18px;
  line-height: 29px;
  font-style: normal;
}
.movie-details {
  margin-top: 10px;
  .movie-title {
    color: rgba(33, 33, 33, 0.8);
    font-family: "ProximanovaSemibold";
    font-size: 20px;
    line-height: 29px;
    font-style: normal;
  }
  .movie-status {
    text-transform: uppercase;
    color: rgba(33, 33, 33, 0.9);
    font-family: "HelveticaNeueMedium";
    font-size: 16px;
    line-height: 23px;
    span {
      font-weight: bold;
    }
  }
}
.subs-quality {
  margin: 10px 0px;
  .gender-label {
    display: inline-block;
    margin-right: 10px;
    color: #212121;
    font-family: "HelveticaNeueMedium";
    font-size: 20px;
    line-height: 22px;
  }
  label {
    color: #212121;
    font-family: "HelveticaNeueMedium";
    font-size: 16px;
    line-height: 22px;
    cursor: pointer;
  }
}
.vlt-radio {
  position: relative;
  &.inline {
    display: inline-block;
    margin-right: 15px;
  }
  input {
    opacity: 0;
    position: absolute;
    &:checked {
      + label::after {
        width: 7px;
        height: 7px;
        left: 4px;
        top: 6px;
        border-radius: 50%;
        background-color: black;
      }
      + label {
        font-weight: 600 !important;
      }
    }
  }
  label {
    position: relative;
    padding-left: 20px;
    font-weight: 300;
    &::before,
    &::after {
      position: absolute;
      content: "";
    }
    &::before {
      width: 15px;
      height: 15px;
      border-radius: 50%;
      left: 0;
      top: 2px;
      border: 2px solid white;
      border-color: black;
    }
  }
}
.price {
  margin: 10px 0px;
  // float: right;
  p {
    color: #212121;
    font-family: "ProximanovaRegular";
    font-size: 18px;
    line-height: 22px;
    float: right;
    margin-left: 0%;
    span {
      color: #212121;
      font-family: "ProximanovaBold";
      font-size: 24px;
      line-height: 22px;
      font-weight: bold;
      // margin: 0 5px;
    }
  }
}
.price-info {
  color: black;
  float: right;
  img {
    width: 18px;
    opacity: 0.8;
    &:hover {
      opacity: 1;
    }
    // margin-left: 10px;
  }
}
.slide-enter-active {
  -moz-transition-duration: 0.2s;
  -webkit-transition-duration: 0.2s;
  -o-transition-duration: 0.2s;
  transition-duration: 0.2s;
  -moz-transition-timing-function: ease-in;
  -webkit-transition-timing-function: ease-in;
  -o-transition-timing-function: ease-in;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  -moz-transition-duration: 0.2s;
  -webkit-transition-duration: 0.2s;
  -o-transition-duration: 0.2s;
  transition-duration: 0.2s;
  -moz-transition-timing-function: ease-out;
  -webkit-transition-timing-function: ease-out;
  -o-transition-timing-function: ease-out;
  transition-timing-function: ease-out;
}

.slide-enter-to,
.slide-leave {
  max-height: 100px;
  overflow: hidden;
}

.slide-enter,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}
.price-detail {
  margin-left: 0px;
  margin-right: 0px;
}
.amount-label {
  color: #70787f;
  font-family: "ProximanovaRegular";
  font-size: 18px;
  line-height: 22px;
  margin: 8px 0;
}
.amount-style {
  margin: 8px 0;
  text-align: center;
  color: #70787f;
  font-family: "ProximanovaRegular";
  font-size: 18px;
  line-height: 22px;
}
.mlmr0 {
  margin-left: 0;
  margin-right: 0;
}
.plpr0 {
  padding-left: 0;
  padding-right: 0;
}
.gift-container {
  margin: 20px 0;
  min-height: 90px;
  padding: 15px;
  box-shadow: 0 0px 10px rgba(0, 0, 0, 0.25), 0 2px 5px rgba(0, 0, 0, 0.22);
  .gift {
    .small {
      text-align: center;
    }
  }
  .gift-share-title {
    color: rgba(33, 33, 33, 0.8);
    font-family: "HelveticaNeueMedium";
    font-size: 20px;
    font-weight: bold;
    line-height: 25px;
    text-transform: uppercase;
    margin-top: 5%;
    text-align: center;
  }
  .gift-arrow {
    width: 25px;
    margin-top: 18%;
    transform: rotate(-90deg);
    cursor: pointer;
  }
  .gift-detail-open {
    text-align: start !important;
    margin-top: 3%;
    font-weight: 500 !important;
  }
  .gift-detail {
    margin: 10px 0;
    .recipient-label {
      color: #212121;
      font-family: "HelveticaNeueMedium";
      font-size: 14px;
      line-height: 16px;
      text-shadow: 1px 1px #ffffff;
    }
    .recipient-input {
      border-bottom: 0.5px solid grey;
    }
    .vlt-input-group {
      margin: 15px 0;
    }
  }
  .your-gifting {
    text-transform: uppercase;
    color: rgba(33, 33, 33, 0.8);
    font-family: "HelveticaNeueMedium";
    font-size: 20px;
    font-weight: bold;
    line-height: 25px;
    width: 300px;
    margin-top: 8%;
  }
  .gift-edit {
    cursor: pointer;
    text-align: end;
    text-transform: uppercase;
    color: #dc4255;
    font-family: "HelveticaNeueMedium";
    font-size: 16px;
    font-weight: 500;
    line-height: 19px;
    margin-top: 10px;
  }
  .gift-remove {
    cursor: pointer;
    text-transform: uppercase;
    color: rgba(33, 33, 33, 0.8);
    font-family: "HelveticaNeueMedium";
    font-size: 16px;
    font-weight: 500;
    line-height: 19px;
    margin-top: 10px;
  }
}
.country {
  .country-name {
    float: left;
  }
  .selected-country {
    min-height: 30px;
    img {
      width: 25px;
    }
    p {
      color: #212121;
      font-family: "HelveticaNeueMedium";
      font-size: 14px;
      font-weight: 500;
      line-height: 17px;
    }
  }
  #countryArrow {
    width: 20px;
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
  }
  .country-list {
    max-height: 200px;
    z-index: 100;
    width: 230px;
    overflow: auto;
    position: relative;
    background: #ffffff;
    color: #212121;
    margin-left: -15px;
    // margin-top: 25px;
    box-shadow: 0 0 1px rgba(76, 86, 103, 0.25),
      0 2px 18px rgba(31, 37, 50, 0.32);
    div.plpr0 {
      margin: 5px 0;
      cursor: pointer;
      p {
        margin-top: 5px;
      }
      &:hover {
        background-color: #212121;
        color: #ffffff;
      }
      img {
        width: 30px;
      }
    }
  }
}
.coupon-container {
  border: 1px solid #bfbfbf;
  border-radius: 6px;
  padding: 5px 15px;
  margin: 20px 0;
  .coupon {
    border: 0;
    font-size: 22px;
    min-height: 30px;
    width: 100%;
    background-color: transparent;
    color: rgba(0, 0, 0, 1);
    margin-top: 5px;
    word-break: break-word;
    &::placeholder {
      opacity: 0.4;
      color: rgba(0, 0, 0, 1);
      font-family: "ProximanovaSemibold";
      font-size: 22px;
      font-weight: 500;
      line-height: 34px;
    }
  }
  .apply {
    text-transform: uppercase;
    color: #4558dd;
    font-family: "ProximanovaBold";
    font-size: 22px;
    font-weight: bold;
    line-height: 34px;
    cursor: pointer;
    margin-top: 5px;
    text-align: end;
    opacity: 0.85;
    &:hover {
      opacity: 1;
    }
  }
}
.payment-container {
  .pay-using {
    text-transform: uppercase;
    margin-bottom: 20px;
    color: rgba(33, 33, 33, 0.9);
    font-family: "HelveticaNeueMedium";
    font-size: 24px;
    line-height: 29px;
  }
  .payment-type-image {
    margin: 0 15px -5px;
  }
}
.card-container {
  /* Hide HTML5 Up and Down arrows. */
  input[type="number"].card-number::-webkit-outer-spin-button,
  input[type="number"].card-number::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type="number"].card-number {
    -moz-appearance: textfield;
  }
  .card-input {
    color: #212121;
    font-family: "HelveticaNeueMedium";
    font-size: 16px;
    // line-height: 18px;
    border: 0;
    height: 40px;
    width: 100%;
    border-bottom: 1.2px solid #b5b5b5;
    background-color: transparent;
    margin-bottom: 20px;

    &::placeholder {
      font-size: 16px;
      color: #212121;
      font-family: "HelveticaNeueMedium";
      // line-height: 18px;
    }
  }
  .card-mmyy {
    width: 40px;
    letter-spacing: 10px;

    &::placeholder {
      letter-spacing: 2px;
    }
  }
  .card-cvv {
    width: 50px;
    letter-spacing: 5px;
  }
}
.vlt-checkbox {
  /* The container */
  .container {
    display: block;
    padding-left: 0;
    cursor: pointer;
    color: #212121;
    font-family: "HelveticaNeueMedium";
    font-size: 16px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  /* Hide the browser's default checkbox */
  .container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  /* Create a custom checkbox */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #ffffff;
    border: 1px solid black;
    border-radius: 4px;
  }

  /* On mouse-over, add a grey background color */
  .container:hover input ~ .checkmark {
    background-color: #ffffff;
  }

  /* When the checkbox is checked, add a blue background */
  .container input:checked ~ .checkmark {
    background-color: #ffffff;
  }

  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  /* Show the checkmark when checked */
  .container input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the checkmark/indicator */
  .container .checkmark:after {
    left: 7px;
    top: 1px;
    width: 8px;
    height: 13px;
    border: solid black;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
}
.payment-success {
  color: #1b1b1b;
  font-family: "ProximanovaSemibold";
  font-size: 22px;
  font-weight: bold;
  margin: 2% 20%;
  text-align: center;
}
.success-info {
  p {
    color: #212121;
    font-family: "ProximanovaRegular";
    font-size: 16px;
    // margin: 5px 0;
    &:first-child {
      // margin: 10px 0;
    }
  }
}
.amount-info {
  // margin: 20px 0;
  .doller {
    color: rgba(33, 33, 33, 0.9);
    font-family: "ProximanovaRegular";
    font-size: 24px;
    margin-right: 5px;
  }
  p {
    margin: 5px 0;
    &:nth-child(1) {
      margin: 10px 0;
    }
  }
}
.amount-recived {
  color: rgba(33, 33, 33, 0.9);
  font-family: "ProximanovaBold";
  font-size: 20px;
  font-weight: bold;
  line-height: 29px;
}
.transactionandorderid {
  opacity: 0.6;
  color: #212121;
  font-family: "ProximanovaRegular";
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
}
.success-price {
  color: rgba(33, 33, 33, 1);
  font-family: "ProximanovaBold";
  font-size: 26px;
  font-weight: bold;
  line-height: 41px;
}
.purchased-content {
  color: rgba(33, 33, 33, 0.9);
  font-family: "HelveticaNeueMedium";
  font-size: 24px;
  font-weight: bold;
  line-height: 29px;
  text-transform: uppercase;
  margin: 0 0 10px 0;
}
.after-success {
  color: #212121;
  text-align: end;
  font-family: "HelveticaNeueMedium";
  span {
    color: #d0021b;
    font-size: 12px;
    font-weight: bold;
    line-height: 19px;
  }
}
.succes-movie-title {
  color: rgba(33, 33, 33, 0.9);
  font-family: "HelveticaNeueMedium";
  font-size: 18px;
  font-weight: bold;
  line-height: 23px;
}
.purchased-content-image {
  // height: 200px;
  margin-bottom: 5%;
  div.outer {
    // margin: 3% 35%;
    margin-top: 5%;
    height: 100%;
    text-align: center;
    img.contentImage {
      border-radius: 5px;
      width: 22%;
    }
  }
  p {
    color: #70787f;
    font-family: "ProximanovaSemibold";
    font-size: 16px;
    font-weight: bold;
    text-align: center;
  }
}
.play {
  width: 50px;
  position: relative;
  top: 45%;
  left: 45%;
}
.quality-radio {
  margin-right: 10px !important;
}
.header-success-close {
  float: right;
  width: 30px;
  cursor: pointer;
}
.hrline {
  margin: 3% 0;
  border-bottom: 1px solid #acacac;
}
.purchaseBtn {
  .logo-container {
    background: #ffffff;
    padding: 10px;
    width: 30%;
    float: left;
    margin-left: 5%;
    margin-right: 4%;
  }
  p {
    font-family: "ProximanovaSemibold";
    font-size: 22px;
    float: left;
    font-weight: bold;
    margin-top: 15px;
  }
}
.purchase-success {
  width: 30px !important;
  height: 30px !important;
  float: right;
  position: absolute;
  left: 56%;
  margin-top: -10px;
  background-color: #6ac259;
  border-radius: 50%;
  img {
    width: 80%;
    margin-top: 10%;
  }
}

.success-message {
  color: #3c763d;
  background-color: #dff0d8;
  border-color: #d6e9c6;
  border-radius: 4px;
  text-align: center;
  padding: 8px;
  margin-top: 20px;
  p {
    font-size: 20px;
  }
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 576px) {
  .payment-popup {
    .popup-box {
      min-width: 250px;
    }
    .box-header {
      padding: 10px;
      h6 {
        font-size: 20px;
      }
    }
  }
  .coupon-container {
    border: 1px solid #bfbfbf;
    border-radius: 6px;
    padding: 5px 15px;
    margin: 20px 0;
    .coupon {
      border: 0;
      font-size: 22px;
      min-height: 30px;
      width: 130%;
      background-color: transparent;
      color: rgba(0, 0, 0, 1);
      margin-top: 5px;
      word-break: break-word;
      &::placeholder {
        opacity: 0.4;
        color: rgba(0, 0, 0, 1);
        font-family: "ProximanovaSemibold";
        font-size: 22px;
        font-weight: 500;
        line-height: 34px;
      }
    }
    .apply {
      text-transform: uppercase;
      color: #4558dd;
      font-family: "ProximanovaBold";
      font-size: 22px;
      font-weight: bold;
      line-height: 34px;
      cursor: pointer;
      margin-top: 5px;
      text-align: end;
      opacity: 0.85;
      &:hover {
        opacity: 1;
      }
    }
  }
  .payment-success {
    margin: 2% 0;
    color: #1b1b1b;
    font-family: "ProximanovaSemibold";
    font-size: 18px;
    font-weight: bold;
    margin: 2% 20%;
    text-align: center;
  }
  .purchase-success {
    width: 20px !important;
    height: 20px !important;
  }
}
/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) and (max-width: 992px) {
  .payment-popup {
    .popup-box {
      min-width: 500px;
    }
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
}
</style>



// WEBPACK FOOTER //
// src/components/Popups/Payment.vue